import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TerminalService {

  constructor(private http: HttpClient) {}
  private _data: BehaviorSubject<any> = new BehaviorSubject(null);

  get data$(): Observable<any> {
    return this._data.asObservable();
}

  getAll(): Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}terminal/v1`);
  }

  getAllResolver(): Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}terminal/v1`).pipe(
                    tap((response: any) => {
                        this._data.next(response);
                    })
                );;
  }

  getLastIntegrationResult(terminal) {
    return this.http.get<any>(`${environment.apis.lineupUrl}monitoring/v1/lineup/${terminal}`);

  }

  getLastIntegrationCargo(terminal, lineupId) {
    return this.http.get<any>(`${environment.apis.lineupUrl}monitoring/v1/cargo-readiness/${terminal}/call/${lineupId}`);

  }

  

}